<template>
  <page
    title="Rug"
    class="complaint"
    :image="{
      src: '/assets/img/body_parts/Rug_m.jpg',
      alt: 'Rug',
    }"
    :page-menu-items="menu_items"
  >
    <complaint
      title="Rug"
      image="/assets/img/body_parts/Rug_m.jpg"
      :employees="['Mario', 'Lars', 'Jeroen']"
      :gradient="true"
    >
      <p>
        De wervelkolom bestaat uit 7 nekwervels, 12 rugwervels met
        ribverbindingen en 5 lumbale wervels zonder ribverbindingen. Iedere
        wervel is verbonden met de boven- en onderliggende wervel middels een
        discus en twee facetgewrichten. Hier om heen zit een wirwar van banden
        en spieren. Al met al een complex geheel. Het is dan ook niet raar dat
        de lage rugklacht de meest voorkomende klacht is die we bij de
        fysiotherapie tegen komen in Nederland. Bij Faam Fysiotherapie zien we
        dan ook veel mensen met lage rugpijn. Mede door de extra kennis die we
        in we in huis hebben vanwege de specialisatie manuele therapie kunnen we
        gelukkig vaak goed helpen bij deze pijnklachten.
      </p>
    </complaint>
    <complaint title="Dysfunctie ribgewrichten">
      <p>
        Dysfunctie van de ribgewrichten, ook bekend als costovertebrale of
        costosternale gewrichtsdysfunctie, is een aandoening waarbij de
        gewrichten tussen de ribben en de wervelkolom of het borstbeen niet goed
        functioneren. Dit kan leiden tot pijn en bewegingsbeperkingen in de
        borstkas, rug en soms zelfs de schouders. De symptomen van
        ribgewrichtsdysfunctie kunnen variëren, maar de meest voorkomende zijn:
        pijn, bewegingsbeperking, gevoeligheid en uitstralende pijn.
      </p>
    </complaint>
    <complaint title="Kyfose en scoliose">
      <p>
        Kyfose is een aandoening waarbij er een abnormale kromming van de
        wervelkolom naar voren ontstaat, meestal in de thoracale (midden) rug.
        Dit resulteert in een gebogen of ronde rug, wat ook wel een "bolle rug"
        wordt genoemd. Kyfose kan variëren van mild tot ernstig en kan leiden
        tot pijn en bewegingsbeperkingen.
      </p>
      <p>
        Scoliose is een aandoening waarbij er een zijwaartse kromming van de
        wervelkolom optreedt. Deze kromming kan C- of S-vormig zijn en kan
        voorkomen in de thoracale (midden) of lumbale (onder) rug. Scoliose kan
        leiden tot asymmetrie van de schouders, ribben en heupen.
      </p>
      <p>
        De symptomen van een kyfose of scoliose kunnen variëren, maar de meest
        voorkomende zijn asymmetrie, rugklachten, verminderde flexibiliteit en
        bewegingsvrijheid, vermoeidheid en ademhalingsproblemen.
      </p>
    </complaint>
    <complaint title="Lage rugklachten">
      <p>
        Lage rugklachten, ook wel lage rugpijn genoemd, zijn een veelvoorkomend
        probleem dat mensen van alle leeftijden treft. Deze pijn kan variëren
        van een lichte, zeurende pijn tot een scherpe, intense pijn die het
        moeilijk maakt om dagelijkse activiteiten uit te voeren. Lage
        rugklachten kunnen plotseling optreden of zich geleidelijk ontwikkelen
        en kunnen acute (kortdurende) of chronische (langdurige) pijn
        veroorzaken. Als er een röntgenfoto of een MRI-scan wordt gemaakt dan is
        er eigenlijk weinig specifiek te zien bij deze klachten. Blijf actief en
        doe oefeningen die de rug- en buikspieren versterken.
      </p>
    </complaint>
    <complaint title="Lumbale kanaalstenose">
      <p>
        Lumbale kanaalstenose is een aandoening waarbij de wervelkolom in de
        onderrug (lumbale regio) vernauwd raakt, waardoor druk op de zenuwen
        ontstaat. Deze vernauwing kan leiden tot pijn, gevoelloosheid en zwakte
        in de benen en onderrug. Het is een veelvoorkomende oorzaak van lage
        rugpijn en beenpijn bij ouderen. De symptomen van lumbale kanaalstenose
        kunnen variëren, afhankelijk van de ernst van de vernauwing. De meest
        voorkomende symptomen zijn: lage rugpijn, beenpijn, gevoelloosheid of
        tintelingen, spierzwakte en verminderde reflexen.
      </p>
    </complaint>
    <complaint title="Lumbosacraal radiculair syndroom en hernia (HNP)">
      <p>
        Lumboradiculair syndroom, vaak benoemd als ischias, is een aandoening
        waarbij een zenuwwortel in de lage rug (lumbaal gebied) geïrriteerd of
        bekneld raakt. Dit leidt tot pijn, gevoelloosheid, tintelingen en soms
        zwakte die uitstraalt vanuit de lage rug naar een of beide benen. De
        symptomen volgen vaak het verloop van de aangetaste zenuw en kunnen
        variëren van mild tot ernstig. Een hernia, specifiek een hernia nuclei
        pulposi (HNP), ontstaat wanneer een tussenwervelschijf uitpuilt en op
        een zenuw drukt. Dit kan pijn, gevoelloosheid en zwakte veroorzaken,
        meestal in de benen.
      </p>
    </complaint>
    <complaint title="Spondylolisthesis">
      <p>
        Spondylolisthesis is een aandoening waarbij een wervel naar voren
        verschuift ten opzichte van de wervel eronder. Dit kan druk uitoefenen
        op de zenuwen en leiden tot pijn en neurologische symptomen.
        Spondylolisthesis kan het gevolg zijn van spondylolyse of kan ontstaan
        door degeneratieve veranderingen, aangeboren afwijkingen of een trauma.
      </p>
    </complaint>
    <complaint title="Spondylolyse">
      <p>
        Spondylolyse is een aandoening waarbij er een defect of breuk optreedt
        in een van de wervellichamen, meestal in de pars interarticularis, een
        dunne botbrug aan de achterkant van de wervel. Deze aandoening komt vaak
        voor bij jonge atleten en kan leiden tot pijn en instabiliteit van de
        wervelkolom.
      </p>
    </complaint>
    <complaint title="Spondylose">
      <p>
        Spondylose is een algemene term die verwijst naar de degeneratieve
        veranderingen in de wervelkolom als gevolg van ouderdom. Het is een vorm
        van artrose die de wervels en tussenwervelschijven aantast, wat kan
        leiden tot pijn en stijfheid in de rug.
      </p>
    </complaint>
  </page>
</template>

<script>
import Page from "@/layout/page.vue";
import Complaint from "@/components/sections/complaint.vue";

import { titleToId } from "@/utilities.js";

export default {
  name: "Rugklachten",
  head: {
    title: "Faam | Rugklachten",
    meta: [
      {
        name: "description",
        content:
          "Vind verlichting voor uw rugklachten bij Faam Fysiotherapie in Uden. Onze deskundige therapeuten bieden gepersonaliseerde behandelingen om pijn te verminderen en de mobiliteit te verbeteren. Ontdek hoe wij u kunnen helpen bij het herstel van rugklachten.",
      },
    ],
  },
  components: {
    Page,
    Complaint,
  },
  data() {
    return {
      items: [
        { title: "Dysfunctie ribgewrichten" },
        { title: "Kyfose en scoliose" },
        { title: "Lage rugklachten" },
        { title: "Lumbale kanaalstenose" },
        { title: "Lumbosacraal radiculair syndroom en hernia (HNP)" },
        { title: "Spondylolisthesis" },
        { title: "Spondylolyse" },
        { title: "Spondylose" },
      ],
    };
  },
  computed: {
    menu_items() {
      return this.items.map((item) => {
        return {
          title: item.title,
          url: `#${titleToId(item.title)}`,
        };
      });
    },
  },
};
</script>

<style lang="less">
section {
  &:not(:last-child):not(:first-child):not(:nth-child(2)) {
    border-bottom: 1px solid #4e4d4d;
  }
}
</style>
